import React, { useState } from 'react';
import { Palette, Check } from 'lucide-react';
import { THEMES, applyTheme, getTheme } from '../theme';

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(getTheme());
  const [open, setOpen] = useState(false);
  const pick = (key) => { setTheme(key); applyTheme(key); };

  return (
    <div className="relative">
      <button onClick={() => setOpen((o) => !o)} aria-label="Theme"
        className="w-10 h-10 rounded-2xl surface card-lux flex items-center justify-center" style={{ color: 'var(--muted)' }}>
        <Palette size={18} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-64 surface rounded-2xl card-lux p-4 z-50">
            <div className="text-[11px] font-bold uppercase tracking-wide mb-3" style={{ color: 'var(--muted)' }}>Theme</div>
            <div className="grid grid-cols-2 gap-2.5">
              {THEMES.map((t) => {
                const on = theme === t.key;
                return (
                  <button key={t.key} onClick={() => pick(t.key)}
                    className="flex items-center gap-2.5 p-2 rounded-xl border transition-colors text-left"
                    style={on ? { borderColor: 'var(--acc)', background: 'var(--acc-soft)' } : { borderColor: 'var(--border)' }}>
                    {/* two-tone preview: ground + accent */}
                    <span className="w-8 h-8 rounded-lg flex items-end justify-end p-1 shrink-0 relative overflow-hidden" style={{ background: t.c1 }}>
                      <span className="w-3.5 h-3.5 rounded-full" style={{ background: t.c2 }} />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-[12.5px] font-bold truncate" style={{ color: 'var(--text)' }}>{t.label}</span>
                      <span className="block text-[10px]" style={{ color: 'var(--muted)' }}>{t.dark ? 'Dark' : 'Light'}</span>
                    </span>
                    {on && <Check size={15} style={{ color: 'var(--acc2)' }} className="ml-auto shrink-0" />}
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
